import crypto from 'crypto'
import cryptojs from 'crypto-js'

/**
 * SHA256 해싱 함수
 * 앞뒤 공백을 제거하고 소문자로 변환한 후 SHA256으로 해싱합니다.
 * @param input 해싱할 문자열
 * @returns SHA256 해시된 16진수 문자열
 */
export const hashData = (input: string): string => {
  const normalizedInput = input.trim().toLowerCase()

  // Node.js 환경에서는 crypto 모듈 사용
  if (typeof window === 'undefined') {
    return crypto.createHash('sha256').update(normalizedInput).digest('hex')
  }

  // 브라우저 환경에서는 crypto-js 사용
  return cryptojs.SHA256(normalizedInput).toString()
}
